import { strings } from "../i18n/strings.es-AR.js";
import { retryMessage } from "../hooks/useConversation.js";
import { AttachmentCard } from "./AttachmentCard.jsx";
import { Icon } from "./icons.jsx";

// Render estilo WhatsApp: *negrita*, saltos de línea y links tocables.
const URL_RE = /(https?:\/\/[^\s]+)/g;
const BOLD_RE = /\*([^*\n]+)\*/g;

function renderInline(text) {
  const nodes = [];
  let counter = 0;

  for (const linePart of String(text).split("\n")) {
    if (counter > 0) nodes.push(<br />);
    counter++;

    for (const chunk of linePart.split(URL_RE)) {
      if (URL_RE.test(chunk) && chunk.startsWith("http")) {
        nodes.push(
          <a href={chunk} target="_blank" rel="noopener noreferrer" class="break-all font-medium underline">
            {chunk}
          </a>
        );
        continue;
      }
      // negrita *texto*
      let lastIndex = 0;
      for (const match of chunk.matchAll(BOLD_RE)) {
        if (match.index > lastIndex) nodes.push(chunk.slice(lastIndex, match.index));
        nodes.push(<strong>{match[1]}</strong>);
        lastIndex = match.index + match[0].length;
      }
      if (lastIndex < chunk.length) nodes.push(chunk.slice(lastIndex));
    }
  }
  return nodes;
}

export function MessageBubble({ message }) {
  const isUser = message.sender === "user";
  const isAgent = message.sender === "agent";
  const failed = message.status === "failed";
  // Los adjuntos fallidos no se reintentan (los bytes ya no están en memoria).
  const canRetry = failed && !message.isAttachment;

  const bubbleStyle = isUser
    ? failed
      ? `bg-rose-100 text-rose-900 dark:bg-rose-900/70 dark:text-rose-100${canRetry ? " cursor-pointer" : ""}`
      : "bg-flux-primary text-white"
    : "bg-white text-slate-800 dark:bg-slate-800 dark:text-slate-100";

  return (
    <div class={`flex ${isUser ? "justify-end" : "justify-start"}`}>
      <div
        // En desktop la ventana es más ancha: se acota la burbuja para que la
        // línea no se estire hasta ser incómoda de leer.
        class={`max-w-[85%] whitespace-pre-wrap break-words rounded-2xl px-3.5 py-2 text-sm leading-relaxed shadow-sm md:max-w-[72%] ${bubbleStyle} ${message.status === "sending" ? "opacity-60" : ""}`}
        onClick={canRetry ? () => retryMessage(message.key) : undefined}
      >
        {isAgent && (
          <span class="mb-0.5 flex items-center gap-1 text-[11px] font-semibold uppercase tracking-wide text-flux-navy-mid dark:text-flux-cyan">
            <Icon name="user" size={12} /> {strings.agentLabel}
          </span>
        )}
        {renderInline(message.text)}
        {message.attachment && <AttachmentCard attachment={message.attachment} />}
        {failed && (
          <span class="mt-1 block text-xs font-medium text-rose-600">
            {message.error || (canRetry ? strings.messageFailed : strings.errorGeneric)}
          </span>
        )}
      </div>
    </div>
  );
}
